import EventHubMixin from '@/mixins/EventHub.js'
import TimeMixin from '@/mixins/Time.js'
import SizesMixin from '@/mixins/Sizes.js'
import MouseMixin from '@/mixins/Mouse.js'

export default
{
    name: 'app-interaction-tank',

    mixins:
    [
        TimeMixin,
        EventHubMixin,
        SizesMixin,
        MouseMixin
    ],

    props:
    {
        content: { type: Object, default: () => {} }
    },

    data()
    {
        return {
            height: 600,
            isOver: false,
            isStarted: false
        }
    },

    created()
    {
        this.height = window.innerHeight
    },

    mounted()
    {
        this.setSlider()
    },

    methods:
    {
        onResize()
        {
            this.height = window.innerHeight
            this.slider.resize()
        },

        setSlider()
        {
            this.slider = {}

            this.slider.$container = this.$refs.sliderContainer
            this.slider.$gutter = this.$refs.sliderGutter
            this.slider.$cursor = this.$refs.sliderCursor

            this.slider.progress = 0
            this.slider.x = 0
            this.slider.clampedX = 0
            this.slider.width = 800

            this.slider.resize = () =>
            {
                this.slider.width = this.slider.$gutter.offsetWidth - this.slider.$cursor.offsetWidth
            }
            this.slider.resize()

            this.drag = {}
            this.drag.previous = 0
            this.drag.current = 0

            this.slider.events = {}

            /**
             * Mouse
             */
            this.slider.events.mouseDown = (_event) =>
            {
                _event.preventDefault()

                this.drag.previous = _event.clientX
                this.drag.current = _event.clientX

                this.slider.x = this.slider.clampedX

                window.addEventListener('mousemove', this.slider.events.mouseMove)
                window.addEventListener('mouseup', this.slider.events.mouseUp)
            }

            this.slider.events.mouseMove = (_event) =>
            {
                _event.preventDefault()

                // X
                this.drag.current = _event.clientX
                const delta = this.drag.current - this.drag.previous
                this.drag.previous = this.drag.current

                this.slider.x += delta

                // Clamped X
                this.slider.clampedX = this.slider.x

                if(this.slider.clampedX < 0)
                {
                    this.slider.clampedX = 0
                }

                if(this.slider.clampedX > this.slider.width)
                {
                    this.slider.clampedX = this.slider.width
                }

                this.slider.$cursor.style.transform = `translateX(${this.slider.clampedX}px)`

                // Progress
                this.slider.progress = this.slider.clampedX / this.slider.width

                // Started
                if(!this.isStarted && this.slider.progress > 0.02)
                {
                    this.isStarted = true
                }

                // Over
                if(!this.isOver && this.slider.progress > 0.99)
                {
                    this.isOver = true
                }

                // Send value
                this.$eventHub.$emit('experience.tank.updateProgress', this.slider.progress)
            }

            this.slider.events.mouseUp = (_event) =>
            {
                _event.preventDefault()
                window.removeEventListener('mousemove', this.slider.events.mouseMove)
                window.removeEventListener('mouseup', this.slider.events.mouseUp)
            }

            this.slider.$cursor.addEventListener('mousedown', this.slider.events.mouseDown)

            /**
             * Touch
             */
            this.slider.events.touchStart = (_event) =>
            {
                // _event.preventDefault()

                this.drag.previous = _event.changedTouches[0].screenX
                this.drag.current = _event.changedTouches[0].screenY

                this.slider.x = this.slider.clampedX

                window.addEventListener('touchmove', this.slider.events.touchMove)
                window.addEventListener('touchend', this.slider.events.touchEnd)
            }

            this.slider.events.touchMove = (_event) =>
            {
                // _event.preventDefault()

                // X
                this.drag.current = _event.changedTouches[0].screenX
                const delta = this.drag.current - this.drag.previous
                this.drag.previous = this.drag.current

                this.slider.x += delta

                // Clamped X
                this.slider.clampedX = this.slider.x

                if(this.slider.clampedX < 0)
                {
                    this.slider.clampedX = 0
                }

                if(this.slider.clampedX > this.slider.width)
                {
                    this.slider.clampedX = this.slider.width
                }

                this.slider.$cursor.style.transform = `translateX(${this.slider.clampedX}px)`

                // Progress
                this.slider.progress = this.slider.clampedX / this.slider.width

                // Started
                if(!this.isStarted && this.slider.progress > 0.02)
                {
                    this.isStarted = true
                }

                // Over
                if(!this.isOver && this.slider.progress > 0.99)
                {
                    this.isOver = true
                }

                // Send value
                this.$eventHub.$emit('experience.tank.updateProgress', this.slider.progress)
            }

            this.slider.events.touchEnd = () =>
            {
                // _event.preventDefault()

                window.removeEventListener('touchmove', this.slider.events.touchMove)
                window.removeEventListener('touchend', this.slider.events.touchEnd)
            }

            this.slider.$cursor.addEventListener('touchstart', this.slider.events.touchStart)
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/app-interaction-tank/script.js